import type { ContentFolder } from 'services/folders/entities';
import { removeEmptySubfolders } from '../common/folderNavigation';
import { folderSearch } from '../common/folderSearch';
import type { ContentWithFolder } from '../common/folderSearch';

export type { ContentWithFolder };

export function searchFoldersWithNavigation(
  rootFolder: ContentFolder,
  currentFolder: ContentFolder,
  searchTerm: string
): { folders: ContentFolder[]; contents: ContentWithFolder[] } {
  if (searchTerm === '') {
    const cleanedFolder = removeEmptySubfolders(currentFolder);
    return {
      folders: cleanedFolder.subfolders,
      contents: cleanedFolder.contents,
    };
  }

  const term = searchTerm.toLowerCase();
  return folderSearch(rootFolder, term);
}
